<template>
<div>
      <v-autocomplete
        v-model="value"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="primary"
        hide-selected
        item-text="full_text"
        item-value="id"
        label="Buscar Cliente"
        placeholder="Ingrese nombre, RUT o fantasía..."
        return-object
        outlined
        clearable
        @input="updateValue"
        @change="cambio"
        dense
        :disabled="disabled"
        hide-details="auto"
        class="custom-autocomplete"
      >
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center">
            <v-icon x-small class="mr-2" color="primary">fas fa-user</v-icon>
            <span class="body-2 font-weight-medium">{{item.name}}</span>
          </div>
        </template>
        
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title class="body-2 font-weight-bold">
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle class="caption grey--text d-flex align-center">
              <v-icon x-small class="mr-1">fas fa-id-card</v-icon> {{ item.rut }}
              <v-icon v-if="item.fantasy" x-small class="ml-3 mr-1">fas fa-tag</v-icon> {{ item.fantasy }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>

        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="caption italic grey--text">
                No se encontraron clientes. Escriba para buscar...
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </div>  
</template>

<script>
import {fetchCustomers} from '@/api/customers'
import notifications from '@/utils/notifications'

  export default {
    name:'CustomerComplete2',
    data: () => ({
      descriptionLimit: 60,
      customers: [],
      isLoading: false,
      model: null,
      search:null,
      items: [],
      timer:'',
    }),
    props:['value','status','customer_name','prependIcon','dense','disabled'],
    methods:{
      updateValue(){
        this.value ? this.$emit('input',this.value) : this.$emit('input','')
      },
      cleared(){
        this.$emit('input','')
      },
      cambio(){
        this.$emit('change')
      },
      querySelections (v) {
        this.isLoading = true
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          //sort = '', page = '', page_size = '', search = '', seller = '', status = ''
          await fetchCustomers('',1,-1,v,'',this.status)
          .then((res)=>{
            this.items=res.results.map(item=>{
              return {
                ...item,full_text:`${item.rut} ${item.name}`
              }
            })
          })

          this.isLoading=false
          },800)
        
        
      },
      searchTimeOut() {  
        //Función para hacer búsqueda lazy
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            this.fetch()
        }, 800);
      },
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
      customer_name(val){
        if(val) this.search=val
      }
    },
    
    
  }
</script>